import {ChromaKeyVideoPlayer} from "@ui/general/ChromaKeyVideoPlayer";

/** Фон видео Anam (blue screen) и .gameWrapperAnam */
export const ANAM_VIDEO_BG = "#C2E6F7";

/**
 * Anam / trainer: green-screen (Anam) + blue-screen (Heygen-like) через авто-цвет сверху кадра.
 */
export const TrainerBlueChromaVideo = ({
  videoRef,
  videoId,
  isConnected,
  wrapperClassName,
  playerClassName,
  videoProps,
}) => (
  <ChromaKeyVideoPlayer
    videoRef={videoRef}
    videoId={videoId}
    isConnected={isConnected}
    enableChromaKey
    enableGreenKey={false}
    blueKeyColor={ANAM_VIDEO_BG}
    blueKeyTolerance={40}
    blueKeyFeather={10}
    blueKeyAutoTopBandPx={0}
    blueKeyProtectBrightFrom={185}
    wrapperClassName={wrapperClassName}
    playerClassName={playerClassName}
    videoProps={videoProps}
  />
);
